(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layouthub_cart_related"]) return;
  try {
    
(function(){
    var $global_cart = null;
    const params = {"RELATED_SERVER":"\/collections\/all?view=layouthub-cart-related"};
    const configs = {
        'STORAGE_KEY': 'LH_PRODUCTS_RELATED'
    };
    const LayoutHubStorage = {
        set: function(key, value) {

            localStorage.setItem(key, value);

        },
        get: function(key) {
            if (typeof key === 'string' && localStorage[key]) {
                return localStorage.getItem(key);
            }
            return false;
        },
        isset: function(key) {
            if (localStorage[key]) {
                return true;
            }
            return false;
        }
    };
    Array.prototype.pluck = function(key) {
        return this.map(function(object) { return object[key]; });
    };
    function trackingAjax()
    {
        var open = window.XMLHttpRequest.prototype.open;
        function handleAjaxCart(data)
        {
            window.fetch('/cart.js', {
                method: 'GET',
                headers: {
                    'Content-Type':'application/json'
                }
            })
            .then(function(response){ return response.json()})
            .then(function(cart){
                $global_cart = cart;
                
                if (cart.item_count) {
                    var handles = cart.items.pluck('handle');
                    LayoutHubStorage.set(configs.STORAGE_KEY, JSON.stringify(handles));
                } else {
                    LayoutHubStorage.set(configs.STORAGE_KEY, '[]');
                }
                onAddCart(data.handle, cart);
            })
            .catch(function(){
                    console.log(e.message);
            })
        }
        function openReplacement(method, url, async, user, password) {
           
            this.addEventListener('loadend', function(e){
                    console.log(e);
                console.warn(
                    'Loadend HTTP request : ' +  method +  ' ' + url
                );

                if(url.indexOf("/cart/add.js") >= 0)
                {   
                    let data = JSON.parse(this.responseText);
                    handleAjaxCart(data);

                }   
            });
            return open.apply(this, arguments);
        }
        window.XMLHttpRequest.prototype.open = openReplacement;
    
        (function(ns, fetch){
            if(typeof fetch !== 'function') return;
          
          ns.fetch = function() {
            var out = fetch.apply(this, arguments);
            out.then((res) => {
                if(res.url.indexOf("/cart/add.js") >= 0)
                {
                    res.clone().json()
                    .then(data=>{
                        handleAjaxCart(data);
                    })
                }
                return res;
            })
            return out;
          }
          
        }(window, window.fetch))

    }
    function onAddCart(handle, cart)
    {
        
        if (params.RELATED_SERVER.indexOf('{vendor}') >= 0 || params.RELATED_SERVER.indexOf('{type}') >= 0) {
            window.fetch('/products/' + handle + '.js', {
                method: 'GET',
                headers: {
                    'Content-Type':'application/json'
                }
            })
            .then(function(res){ return res.json()})
            .then(function(product){
                if (params.RELATED_SERVER.indexOf('{vendor}') >= 0 && product.vendor != "") {
                     var url = params.RELATED_SERVER.replace(/\{vendor\}/g, encodeURIComponent(product.vendor) );
                     showPopup(url)
                } else if (params.RELATED_SERVER.indexOf('{type}') >= 0 && product.type != "") {
                    var url = params.RELATED_SERVER.replace(/\{type\}/g, encodeURIComponent(product.type));
                    showPopup(url)
                } else {
                    console.log('Product type or Vendor is empty');
                }
            })
            .catch(function(e){
                console.log(e.message);
            });
        }
        else 
        {
            var url = params.RELATED_SERVER.replace(/\{handle\}/g, handle);
            showPopup(url)
        }

    }
    function showPopup(url)
    {   
           setTimeout(function(){
                 window.fetch(url)
                .then(function(res){return res.text()})
                .then(function(responseText){
                    let popup = document.querySelector('#layouthub-cart_related-popup')
                    if(popup && responseText.indexOf('lh-grid-view-item') > 0)
                    {
                        popup.querySelector('.lh-cart-related-content').innerHTML = responseText;
                        popup.classList.add('lh-show')
                        document.body.classList.add('lh-popup-show')
                    }
                    else 
                        throw new Error('Cannot found popup or content');
                })
                .catch(function(e){
                    console.log(e.message);
                })
           },0)
    }
    function initPopup()
    {
        let popup = document.createElement('div')
            popup.id= 'layouthub-cart_related-popup'
            popup.classList.add('layouthub-popup')
            popup.classList.add('lh-miniapps_cart_related')
            popup.innerHTML = '<div class="lh-popup-bg lh-backdrop"></div>';
        let wrapper = document.createElement('div');
            wrapper.classList.add('lh-popup-wrapper');
            wrapper.innerHTML = `<div class="lh-cart-related-stage"><div class="lh-cart-related-content"></div></div>`
        let close = document.createElement('a');
            close.classList.add('lh-cart-related-close-btn')
            close.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"></path></svg>`;
            close.addEventListener('click', closeModal);
       let  outside = wrapper.querySelector('.lh-cart-related-content');
            outside.addEventListener('click', function(e){  
                if(e.target === this)
                {
                    closeModal(e);
                }
            });
        popup.appendChild(wrapper);
        popup.appendChild(close)
        if(!document.querySelector('#layouthub-cart_related-popup'))
        {
            document.body.appendChild(popup)
        }
    }
    function closeModal(e)
    {
        e.preventDefault();
        let popup = document.querySelector('#layouthub-cart_related-popup')
        if(popup )
        {
            popup.querySelector('.lh-cart-related-content').innerHTML = '';
            popup.classList.remove('lh-show')
            document.body.classList.remove('lh-popup-show')
        }
    }
    function init()
    {
        if(!params.RELATED_SERVER) return 1;
        if(!document.querySelector('.lh-miniapps-cart_related'))
        {
            return 1;
        }

        initPopup();

        trackingAjax();
        window.fetch('/cart.js',{
            method:'GET',
            headers: {
                'Content-Type':'application/json'
            }
        })
        .then(function(res){ return res.json()})
        .then(function(cart){
            $global_cart = cart;
            if (LayoutHubStorage.isset(configs.STORAGE_KEY) && cart.item_count) {
                var handles = cart.items.pluck('handle');
                var storage = JSON.parse(localStorage.getItem(configs.STORAGE_KEY));
                var diff = jQuery(handles).not(storage);
                if (diff.length > 0) {
                    onAddCart(diff.get(0), cart);
                } else {
                    //onAddCart(handles[0], cart);
                }
                LayoutHubStorage.set(configs.STORAGE_KEY, JSON.stringify(handles));

            } else if ((!cart.item_count && LayoutHubStorage.isset(configs.STORAGE_KEY)) || (!cart.item_count && !LayoutHubStorage.isset(configs.STORAGE_KEY))) {
                LayoutHubStorage.set(configs.STORAGE_KEY, '[]');
            } else if (!LayoutHubStorage.isset(configs.STORAGE_KEY) && cart.item_count) {
                var handles = cart.items.pluck('handle');
                onAddCart(handles[0], cart);
                LayoutHubStorage.set(configs.STORAGE_KEY, JSON.stringify(cart.items.pluck('handle')));
            }
        })
        .catch(function(e){
            console.log(e.message);
        });
    }
    init();

})()

        

  } catch(e) { console.error(e); }
})();
})();
